export const selectPaymentServiceConf = (state = {}) => (state.PAYMENT_SERVICE_CONF !== undefined
  ? state.PAYMENT_SERVICE_CONF
  : {});

export const paymentServiceConfSelector = (state = initialState) => (state.payments.PAYMENT_SERVICE_CONF !== undefined
    ? state.payments.PAYMENT_SERVICE_CONF
    : {});

export const selectPaymentServiceResult = (state = {}) => (state.PAYMENT_SERVICE_RESULT !== undefined
      ? state.PAYMENT_SERVICE_RESULT
      : {});

export const selectPaymentServiceConfArrayServices = (state = {}) => (
        state && state.PAYMENT_SERVICE_CONF && state.PAYMENT_SERVICE_CONF.services
        ? state.PAYMENT_SERVICE_CONF.services : []);
  

export const selectOCRScannerData = (state = {}) => (
          state && state.OCR_SCANNER_DATA
          ? state.OCR_SCANNER_DATA : {});

export const selectContactNumberData = (state = {}) => (
  state && state.SET_NUMBER_CONTACTS
  ? state.SET_NUMBER_CONTACTS : null);
         
export const selectPaymentServiceContacts = (state = {}) => (
            state && state.PAYMENT_SERVICE_CONTACTS
            ? state.PAYMENT_SERVICE_CONTACTS : []);

export const getCanEncript = (state = initialState) =>{
  return state.payments.canEncrypt;
}

export const getCanMultiAnalytics = (state = initialState) =>{
  return state.payments.canMultiAnalytics;
}

export const getServiceId = (state = initialState) =>{
  return state.payments.PAYMENT_SERVICE_CONF.services[0].serviceData.info.serviceId;
}

export const getSdkVersion = (state = initialState) =>{
  return state.payments.PAYMENT_SERVICE_CONF.sdkClaroVersion
}

export const getCanSendId = (state = initialState) =>{
  return state.payments.canSendServiceId
}

export const getHasCreditFromUrl = (state = initialState) =>{
  return state.payments.hasCredit
}

export const getCanSendClaroSocioValue = (state = initialState) =>{
  return state.payments.canSendClaroSocioValue
}

export const getCanShowCanCookiesValue = (state = initialState) =>{
  return state.payments.canShowCanCookies
}

export const getParamsFromUrl = (state = initialState) =>{
  return state.payments.params;
}

export const getBundleVersionFromUrl = (state = initialState) =>{
  return state.payments.bundleVersion;
}

export const getBundleIdFromUrl = (state = initialState) =>{
  return state.payments.bundleId;
}

export const getUserInfoSelector = (state = initialState) =>{
  return state.payments.userInfo
}

export const getAppSyncValues = (state = initialState) =>{
  return state.payments.appSyncValues
}
export const getUserInfoLiteSelector = (state = initialState) =>{
  return state.payments.userInfoLite
}

export const getCodeError = (state = initialState) =>{
  return state.payments.codeError
}

export const getMessageSears = (state = initialState) =>{
  return state.payments.searsMessages;
}

export const getTagServiceId = (state = initialState) =>{
  return state.PAYMENT_SERVICE_CONF.tagServiceId;
}

export const getListFavsServices = (state = initialState) =>{
  return state.ResponseSuccess.favorite;
}

export const getListReminder = (state = initialState) =>{
  if(state.getPaymentReminderSucces.data && state.getPaymentReminderSucces.data.reminder){
    return state.getPaymentReminderSucces.data.reminder;
  }
}

export const getListRecentlyPaid = (state = initialState) =>{
  if(state.getPaymentReminderSucces.data && state.getPaymentReminderSucces.data.recentlyPaid){
  return state.getPaymentReminderSucces.data.recentlyPaid;
  }
}

export const getMessageFavServices = (state = initialState) =>{
  return state.favoriteServicesMessages;
}

export const getPendingAmount = (state = initialState) =>{
  return state.pendingAmount
};

export const isTemporalClaroIdSelector = (state = initialState) =>{
  return state.payments.isTemporalClaroId
};

export const isAnonimousSelector = (state = initialState) =>{
  return state.payments.isAnonimous
};
export const isContainerTelcelSelector = (state = initialState) =>{
  return state.payments.isContainerTelcel
};
export const buldleParamsFromUrlSelector = (state = initialState) =>{
  return state.payments.bundleParamsFromUrl
};
export const getTokenizationCardSelector = (state = initialState) =>{
  return state.payments.tokenizationCard
};
export const getSnackBarSuccessSelector = (state = initialState) =>{
  return state.payments.snackBarSuccess
};
export const getLoadingTokenizationCardSelector = (state = initialState) =>{
  return state.payments.loadingTokenizationCard
};
export const getTokenizationOnSelector = (state = initialState) =>{
  return state.payments.tokenizationOn
};
export const getCanBarsBisibilitySelector = (state = initialState) =>{
  return state.payments.canBarsBisibility
};
export const getCanRegisterEmailSelector = (state = initialState) =>{
  return state.payments.canRegisterEmail
};
export const getCanTokenCompleteSelector = (state = initialState) =>{
  return state.payments.canTokenComplete
};
export const getOriginParamsSelector = (state = initialState) =>{
  return state.payments.originParamValue
}
export const getCanScannerSelector = (state = initialState) =>{
  return state.payments.canGetScanner
}

export const getCanTapToAppSelector = (state = initialState) =>{
  return state.payments.canTapToApp
}

export const getTapToAppParamsSelector = (state = initialState) =>{
  return state.payments.tapToAppParams
}

export const getVerifyNfcSelector = (state = initialState) =>{
  return state.payments.verifyNFC
}
export const getResponseReadingNfcSelector = (state = initialState) =>{
  return state.payments.responseReadingNFC
}

export const getSelectedChipValues = (state = initialState) =>{
  return state.payments.selectedChipValues
}



export const getComissionRulesDiscount = (state = initialState) => {
  const commisionRules =
    state.payments &&
    state.payments.commissionRules &&
    Array.isArray(state.payments.commissionRules) &&
    state.payments.commissionRules.length > 0 &&
    state.payments.commissionRules[0];

  const discount = commisionRules && commisionRules.discountArray;
  return discount ? discount : null;
};

export const getCardInfo = (state = initialState) => {
  return state.payments && state.payments.cardInfo
}

export const getServiceName = (state = initialState) =>{
  return state.payments.PAYMENT_SERVICE_CONF.services[0].serviceData.info.serviceName;
}